<template>
    <div id="app">
        <router-view />
    </div>
</template>

<style lang="scss">
#app {
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    //font-family: 'Open Sans', sans-serif!important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

nav {
    padding: 30px;

    a {
        font-weight: bold;
        color: #2c3e50;

        &.router-link-exact-active {
            color: #42b983;
        }
    }
}

.grey.darken-1 {
    background-color: #757575 !important;
    border-color: #757575 !important;
}

.pa-4 {
    padding: 16px !important;
}

.username {
    padding-top: 10px;
}
</style>

<script>
export default {
    methods: {
        setMeta(route) {
            // タイトルを設定
            if (route.meta.title) {
                let setTitle = route.meta.title;
                document.title = setTitle;
            }
            // ディスクリプションを設定
            if (route.meta.desc) {
                let setDesc = route.meta.desc;
                document.querySelector("meta[name='description']").setAttribute("content", setDesc);
            }
        },
    },
    mounted() {
        let route = this.$route;
        this.setMeta(route);
    },
    watch: {
        $route(route) {
            this.setMeta(route);
        },
    },
};
</script>
